import { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import { isMobile } from "react-device-detect";

// Components
import Section from "../../../components/Section/SectionContainer";

// CSS
import styles from "../conference.module.scss";

// Utils
import { formatCarouselArray } from "../../../utils/miscUtils";

export const ConferenceSpeakers = (props) => {
    const { conference } = props;
    const { speakers } = conference || {};

    const [speakerItems, setSpeakerItems] = useState(null);

    /**
     * useEffect
     */

    useEffect(() => {
        const size = isMobile ? 1 : 8;
        speakers && setSpeakerItems(formatCarouselArray(speakers, { size }));
    }, [speakers]);

    /**
     * Constants
     */

    const hasSpeakers = speakers && speakers.length;

    /**
     * End Hooks
     */

    function renderSpeakers() {
        return speakerItems?.map((group, i) => {
            return (
                <Carousel.Item key={i}>
                    <div className={styles.items}>
                        {group.map((item, j) => {
                            const { description, image, name } = item;
                            return (
                                <div className={styles.item} key={j}>
                                    <div
                                        className={styles.image}
                                        style={{
                                            backgroundImage: `url(${image?.sizes?.medium_large})`,
                                        }}
                                    />
                                    <div className={styles.body}>
                                        <span className={styles.name}>
                                            {name}
                                        </span>
                                        <p className={styles.description}>
                                            {description}
                                        </p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </Carousel.Item>
            );
        });
    }

    return hasSpeakers ? (
        <Section classes={styles.speakers}>
            <h1 className={styles.title}>our speakers</h1>
            <Carousel controls={!isMobile} interval={null}>
                {renderSpeakers()}
            </Carousel>
        </Section>
    ) : null;
};
